import { useEffect, useState } from "react";
import { API_BASE_URL } from "../utils/api";

// One shared source for the profile and the ACTIVE company (header, dashboard, Profile), so that
// /profile.php is not called several times at once. The server returns only the company from the current session.
let store = { data: null, loading: false, error: null, started: false };
const subscribers = new Set();
const emit = () => subscribers.forEach((fn) => fn());

async function load() {
  store = { ...store, loading: true, error: null };
  emit();
  try {
    const res = await fetch(`${API_BASE_URL}/profile.php`, { credentials: "include" });
    const json = await res.json();
    store = json?.success
      ? { ...store, data: json, loading: false, error: null }
      : { ...store, data: null, loading: false, error: json?.error || "Greška" };
  } catch {
    store = { ...store, data: null, loading: false, error: "Server nije odgovorio" };
  }
  emit();
}

/** Refresh the profile (after a change of data, image or logo). */
export function notifyProfileChanged() {
  store.started = true;
  load();
}

/** Forget everything (logout, or a test): the next user must not see someone else's data. */
export function resetProfile() {
  store = { data: null, loading: false, error: null, started: false };
  emit();
}

export function useProfile() {
  const [, setTick] = useState(0);
  useEffect(() => {
    const fn = () => setTick((t) => t + 1);
    subscribers.add(fn);
    if (!store.started) {
      store.started = true;
      load();
    }
    return () => subscribers.delete(fn);
  }, []);

  const { data, loading, error } = store;
  return {
    user: data?.success ? data.user : null,
    companies: data?.success ? data.firme || [] : [],
    // "settled": the first response has arrived (successful or not), so the screen may proceed
    settled: data !== null || Boolean(error),
    loading: loading || (!store.started && data === null && !error),
    error,
    reload: notifyProfileChanged,
  };
}
